import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {


  url;
  constructor(private http: HttpClient ) {
    this.url = environment.baseApiUrl + 'admin/';
  }

  get() {
    return this.http.get(environment.production ? environment.baseApiUrl + 'currencies' : environment.baseApiUrlTest + 'currencies').pipe(
      map((response: any) => {
        return response['data'];
      })
    );
  }
  getById(id) {
    return this.http.get(environment.production ? environment.baseApiUrl  + 'currency/' + id : environment.baseApiUrlTest + 'currency/' + id).pipe(
      map((response: any) => {
        return response['data'].code;
      })
    );
  }

}
